var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.getFormattedIdentifierOfLicense(_vm.license)))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-file-certificate"})])
}]

export { render, staticRenderFns }